import { getPublicRoute } from '@/lib/analytics/publicRoutes';
import { webPageStructuredDataGraph } from '@/lib/webPageStructuredData';

const SITE = 'https://lendwisemtg.com';

export const CALCULATOR_SCHEMA_ID = 'lw-calculator-schema';

type CalculatorPage = { path: string; name: string; description?: string; crumb: string };

const PAGES: CalculatorPage[] = [
  {
    path: '/calculators',
    name: 'Mortgage Calculator',
    crumb: 'Mortgage calculator',
  },
  {
    path: '/calculators/affordability',
    name: 'Home Affordability Calculator',
    // Spell out the ratio in schema; the shorter search description uses DTI.
    description: 'Adjust a monthly housing budget and estimate a home price with income, debts, and total debt-to-income ratio in one calculator.',
    crumb: 'Affordability calculator',
  },
  {
    path: '/calculators/refinance',
    name: 'Refinance Calculator',
    crumb: 'Refinance calculator',
  },
  {
    path: '/calculators/buydown',
    name: 'Buydown Calculator',
    crumb: 'Buydown calculator',
  },
  {
    path: '/calculators/discount-points',
    name: 'Mortgage Points Calculator',
    crumb: 'Points calculator',
  },
  {
    path: '/calculators/dscr',
    name: 'DSCR Calculator',
    crumb: 'DSCR calculator',
  },
];

/**
 * Breadcrumbs and a WebPage record for each calculator — the same modest
 * baseline the large calculator publishers ship. No FAQPage (it earns no rich
 * result for a lender) and no SoftwareApplication (it would need real ratings).
 */
export function calculatorStructuredDataGraph(pathname: string): object | null {
  const page = PAGES.find((candidate) => candidate.path === pathname);
  const route = getPublicRoute(pathname);
  if (!page || !route?.indexable) return null;
  const url = `${SITE}${page.path}`;
  const crumbs = [
    { name: 'Resources', item: `${SITE}/resources` },
    ...(page.path === '/calculators'
      ? [{ name: page.crumb, item: url }]
      : [{ name: 'Mortgage calculator', item: `${SITE}/calculators` }, { name: page.crumb, item: url }]),
  ];
  return webPageStructuredDataGraph({
    url,
    name: page.name,
    description: page.description ?? route.description,
    crumbs,
  });
}
